export default {"src":"/_next/static/media/WU.3462bec8.svg","height":18,"width":18};